module.exports = __webpack_public_path__ + "img/unit12.60aee697.jpg";